import axios from "@main/axios";
import {logger} from "@main/helpers/logger";
import actualInfoCard from "@partials/actual-info-card.handlebars";

let isInProgress = false;

export default async function getActualInfoSlides(el, slider, url, size) {

    const wrapper = el.querySelector(".swiper-wrapper");
    const isEnd = el.hasAttribute("data-slider");
    const paginator = el.dataset.paginator;
    const page = el.dataset.page;

    if(!url || !el || !slider) {
        return;
    }

    try {
        if(isInProgress ||
            isEnd) {
            return;
        }

        isInProgress = true;

        const response = await axios({
            url: url,
            method: "GET",
            params: {
                size: size,
                [paginator]: page,
            },
        });

        isInProgress = false;

        const dataPublications = response.data.data.publications;
        const {pageCount} = response.data.data;

        if (pageCount == 0) {
            el.setAttribute("data-slider", "end");
            return;
        }
        
        dataPublications.forEach((card) => {
            const infoPublication = actualInfoCard({
                actualInfoCard: {
                    href: card.HREF,
                    image: card.IMAGE,
                    text: card.TEXT,
                    date: card.DATE,
                    datetime: card.DATETIME,
                },
            });
            wrapper.insertAdjacentHTML("beforeend", infoPublication);
        }); 
        slider.update();        
        el.setAttribute("data-page", Number(page) + 1);
        
        if (page == pageCount) {
            el.setAttribute("data-slider", "end");
            return;
        }
    } catch (e) {
        logger.log(e);
        alert("Что-то пошло не так...\nПопробуйте обновить страницу");
    }
}
